export const houseNumberValidationPattern = /^[\p{Script=Latin}\p{Mark}0-9 /'\-\.]{1,20}$/u
